import React from 'react';
import selectn from 'selectn';
import ProviderSettings from './ProviderSettings';

const ProviderLogo = ({ displayLogout, handleLogout, providerInfo, watchLogo }) => {
    const imgSrc = selectn('images.colorWithPositiveBackground.href', providerInfo);
    const webLink = selectn('links.web.href', providerInfo) || '/watch';
    let target = '';
    const providerImg = imgSrc ? <img src={imgSrc} className="imageLoaded" alt="Provider" /> : null;
    if (providerImg !== null) {
        target = '_blank';
    }

    const loggedInClass = 'playback__header--loggedIn';

    return (
        <div className={`sportbrand ${loggedInClass}`}>
            <a
                className="sportbrand__watch"
                onClick={(event) => {
                    event.preventDefault();
                    window.location = '/watch/';
                }}
            >
                <img src={watchLogo} className="imageLoaded" alt="Watch ESPN" />
            </a>
            <a className="playback__provider sportbrand__provider" target={target} href={webLink}>
                {providerImg}
            </a>
            <ProviderSettings
                displayLogout={displayLogout}
                handleLogout={handleLogout}
                providerInfo={providerInfo}
                providerName={providerInfo.name}
            />
        </div>
    );
};

ProviderLogo.propTypes = {
    displayLogout: React.PropTypes.bool,
    handleLogout: React.PropTypes.func,
    providerInfo: React.PropTypes.object,
    watchLogo: React.PropTypes.string
};

ProviderLogo.defaultProps = {
    providerInfo: {}
};

export default ProviderLogo;



// WEBPACK FOOTER //
// ./app/branding/ProviderLogo.js